export default __webpack_public_path__ + "static/media/User.3c539f03.svg";